import { useQuery } from 'react-query';
import { QueryKeys } from 'utils/queryKeys';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';

export function useSignatures({ contentId }: { contentId: string }) {
  return useQuery({
    queryKey: QueryKeys.getSignatures(contentId),
    queryFn: () => apiDocumentServiceRepository.getSignaturesByContentId(contentId),
  });
}
